export default __webpack_public_path__ + "static/media/offer.94e968e1.png";